module.exports = __webpack_public_path__ + "assets/percentage.a756850c.svg";